import { ShippingInfo } from "src/components/styled/ShippingInfo"
import { useProductContext } from "../context"

export const ProductShippingInfo = () => {
  const { resolvedShippingDate, resolvedFreeShipping, resolvedAvailable } = useProductContext()

  if (!resolvedAvailable) {
    return null
  }

  return <ShippingInfo shippingDate={resolvedShippingDate} freeShipping={resolvedFreeShipping} />
}
